import { Column } from '../Billing/BillItems';

export const PHARMACY_ITEM_REQUEST_COLUMNS: Column[] = [
    { name: 'concept', type: 'autocomplete', validation: '' },
    { name: 'quantity', type: 'number', validation: 'pharmacyRequest' },
];
